import { Component, Input, Output, EventEmitter } from '@angular/core';

import { DataManager } from "techlify-ng";
import { AlertService } from "techlify-ng";
import { RequestErrorService } from "techlify-ng";

import { School } from "./school.model";

/**
 * Controller used to delete a School
 * 
 * @author Floyd Kissoon
 * @since 20180613
 */
@Component({
    selector: 'school-delete',
    templateUrl: "./school-delete.html"
})
export class SchoolDeleteComponent
{
    @Input() school: School;
    @Output() onSave = new EventEmitter<School>();

    constructor(private dataManager: DataManager, private alertService: AlertService,
    private errorHandler: RequestErrorService) { }

    deleteSchool()
    {
        this.dataManager.DELETE("api/school/" + this.school.id).then(
            res =>
            {
                this.onSave.emit(this.school);
                this.alertService.addAlert(res.message, "success");
            },
            error =>
            {
                this.errorHandler.handleError(error);
            }
        );
    }
}